{
  "Accessibility Menu": "Хандалтын цэс",
  "Reset settings": "Тохиргоог дахин тохируулах",
  "Close": "Хаах",
  "Content Adjustments": "Агуулгын тохируулга",
  "Adjust Font Size": "Фонтын хэмжээг тохируулах",
  "Highlight Title": "Гарчгийг онцлох",
  "Highlight Links": "Холбоосуудыг онцлох",
  "Readable Font": "Уншихад хялбар фонт",
  "Color Adjustments": "Өнгөний тохируулга",
  "Dark Contrast": "Харанхуй ялгарал",
  "Light Contrast": "Гэрэлтэй ялгарал",
  "High Contrast": "Өндөр ялгарал",
  "High Saturation": "Өндөр ханалт",
  "Low Saturation": "Бага ханалт",
  "Monochrome": "Нэг өнгө",
  "Tools": "Хэрэгслүүд",
  "Reading Guide": "Унших гарын авлага",
  "Stop Animations": "Анимацийг зогсоох",
  "Big Cursor": "Том курсор",
  "Increase Font Size": "Фонтын хэмжээг нэмэгдүүлэх",
  "Decrease Font Size": "Фонтын хэмжээг багасгах",
  "Letter Spacing": "Үсгийн хоорондын зай",
  "Line Height": "Мөрийн өндөр",
  "Font Weight": "Фонтын жин",
  "Dyslexia Font": "Дислекси фонт",
  "Language": "Хэл",
  "Open Accessibility Menu": "Хандалтын цэсийг нээх",
  "Accessibility Profiles": "Хандалтын профайл",
  "Seizure Safe Profile": "Тамир үүсгэхээс хамгаалсан профайл",
  "Stops animations and reduces color saturation.": "Анимацийг зогсоож, өнгөний ханалтыг бууруулна.",
  "Blind Profile": "Хараагүй хэрэглэгчийн профайл",
  "Activates the screen reader for auditory navigation.": "Сонсголын навигацын зориулалттай дэлгэц уншигчийг идэвхжүүлнэ.",
  "Visually Impaired Profile": "Хараа муутай хэрэглэгчийн профайл",
  "Enhances contrast and readability for low vision.": "Бага хараатай хэрэглэгчдэд зориулсан контраст ба унших чадварыг нэмэгдүүлнэ.",
  "ADHD Friendly Profile": "ADHD-д ээлтэй профайл",
  "Reduces distractions for better focus.": "Анхаарал сарнилыг бууруулж, төвлөрлийг сайжруулна.",
  "Cognitive & Learning Profile": "Оюун ухаан ба суралцах профайл",
  "Helpful tools for reading and comprehension.": "Унших болон ойлгоход туслах хэрэгслүүд.",
  "Motor Impaired Profile": "Моторик чадвар муутай хэрэглэгчийн профайл",
  "Optimizes the site for keyboard-only navigation.": "Зөвхөн клавиатур ашиглан навигацийг сайжруулна.",
  "Headings": "Гарчиг",
  "Landmarks": "Таних тэмдэг",
  "Links": "Холбоосууд",
  "Focus element": "Анхаарал төвлөрөх элемент",
  "Visit link": "Холбоос руу очих"
}